import './vue/vue.js';
import './vue/router.js';

// Laad andere scripts
import './autoload/bootstrap';
import './global/common';
import './global/nav';
import './global/flickity';
import './global/gmaps';
import './global/package-gallery';
import './global/package-order';
import './global/products-sidebar';

import './animations/word-scroll';
import './animations/dotted-line';
import './utils/background-images';

import features from '/features.json';

if (features.woocommerce) {
  import('./features/woocommerce/checkout');
  import('./features/woocommerce/product');
  // import('./features/woocommerce/vatswitch');

  if (features.woocommerce_addtocartmodal) {
    import('./features/woocommerce/addtocart');
  }

  if (features.woocommerce_offer) {
    import('./features/woocommerce/addtooffer');
  }
}

if (features.search) {
  import('./features/search');
}

if (features.tab_notification) {
  import('./features/tab-notification');
}

import.meta.glob(['../images/**', '../fonts/**']);
